import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'

import { REACT_LOADING_DURATION } from '../../Loader/constants'

import {
   BoardsListControllerLoadingWrapper,
   ProjectsOrTeamLoadingWrapper,
   ProjectOrTeamDropDown,
   BoardsListLoadingWrapper
} from './styledComponents'

class BoardsListControllerLoader extends React.Component {
   boardsWidths = [100, 200, 144, 180, 168, 194, 220]
   renderProjectsOrTeamsLoader = () => (
      <ProjectsOrTeamLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={88}
            height={16}
            style={{ marginBottom: 16 }}
         />
         <ProjectOrTeamDropDown>
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={36}
               height={36}
               style={{ borderRadius: 6 }}
            />
            <Skeleton
               duration={REACT_LOADING_DURATION}
               width={178}
               height={36}
               style={{ marginLeft: 8, borderRadius: 4 }}
            />
         </ProjectOrTeamDropDown>
      </ProjectsOrTeamLoadingWrapper>
   )
   renderBoardsListLoader = () => (
      <BoardsListLoadingWrapper>
         {this.boardsWidths.map(width => (
            <Skeleton
               key={width}
               duration={REACT_LOADING_DURATION}
               width={width}
               height={20}
               style={{ marginBottom: 20 }}
            />
         ))}
      </BoardsListLoadingWrapper>
   )
   render() {
      const {
         renderProjectsOrTeamsLoader: RenderProjectsOrTeamsLoader,
         renderBoardsListLoader: RenderBoardsListLoader
      } = this
      return (
         <BoardsListControllerLoadingWrapper>
            <RenderProjectsOrTeamsLoader />
            <RenderBoardsListLoader />
         </BoardsListControllerLoadingWrapper>
      )
   }
}

export default observer(BoardsListControllerLoader)
